import { StyleSheet } from 'react-native';
import type { WcColors } from './matchPickStats.helper';

export function getPickStatsOddsTableStyles(C: WcColors) {
  return StyleSheet.create({
    container: {
      gap: 8,
    },
    marketCard: {
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: 8,
      backgroundColor: C.panel,
      borderWidth: 1,
      borderColor: C.line,
      borderRadius: 12,
      padding: 8,
      paddingHorizontal: 10,
    },
    marketLabelCol: {
      width: 56,
      justifyContent: 'center',
    },
    marketName: {
      fontSize: 10,
      fontWeight: '800',
      color: C.inkDim,
      letterSpacing: 0.3,
    },
    chipsRow: {
      flex: 1,
      flexDirection: 'row',
      gap: 5,
    },
    chip: {
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      paddingVertical: 7,
      paddingHorizontal: 4,
      borderRadius: 8,
      backgroundColor: C.panelHi,
      borderWidth: 1,
      borderColor: C.line,
    },
    chipLabel: {
      fontSize: 9,
      color: C.inkDim,
      fontWeight: '600',
      textAlign: 'center',
      letterSpacing: 0.2,
    },
    chipValue: {
      fontSize: 13,
      fontWeight: '800',
      color: C.ink,
    },
    marketCardColumn: {
      flexDirection: 'column',
      backgroundColor: C.panel,
      borderWidth: 1,
      borderColor: C.line,
      borderRadius: 12,
      padding: 10,
    },
    // ── Correct score grid ──────────────────────────────────────
    scoreGrid: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 5,
      marginTop: 8,
    },
    scoreChip: {
      width: '22%',
      alignItems: 'center',
      justifyContent: 'center',
      paddingVertical: 5,
      paddingHorizontal: 2,
      borderRadius: 7,
      backgroundColor: C.panelHi,
      borderWidth: 1,
      borderColor: C.line,
      gap: 1,
    },
    scoreChipScore: {
      fontSize: 10,
      fontWeight: '800',
      color: C.ink,
      letterSpacing: 0.3,
    },
    scoreChipOdd: {
      fontSize: 9,
      fontWeight: '600',
      color: C.inkMute,
    },
    moreBtn: {
      marginTop: 6,
      paddingVertical: 7,
      borderRadius: 10,
      borderWidth: 1,
      borderStyle: 'dashed',
      borderColor: C.purple + '55',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      gap: 5,
    },
    moreBtnPressed: { opacity: 0.7 },
    moreBtnText: {
      fontSize: 10,
      fontWeight: '700',
      color: C.purpleHi,
      letterSpacing: 0.4,
      textTransform: 'uppercase',
    },
    emptyText: {
      fontSize: 13,
      color: C.inkMute,
      paddingVertical: 16,
      textAlign: 'center',
    },
  });
}
